import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * LinearProgress
 */
export default function LinearProgress(props) {
  const {
    infoFormat,
    className,
    value,
    max,
    min,
    prefixCls,
    showInfo,
    indicator,
    indicatorPosition,
    strokeWidth,
    duration,
    pathProps,
    pathColor,
    color,
    ...other
  } = props;
  const classes = classNames(
    prefixCls,
    {
      [`${prefixCls}-color-${color}`]: value !== max,
      [`${prefixCls}-color-success`]: value === max,
    },
    className,
  );
  const bgStyle = strokeWidth
    ? {
        height: strokeWidth,
      }
    : {};
  const indicatorStyles = {
    top: {
      left: `${(value / (max - min)) * 100}%`,
      transform: `translateX(-${50}%)`,
      bottom: '100%',
    },
    bottom: {
      left: `${(value / (max - min)) * 100}%`,
      transform: `translateX(-${50}%)`,
      top: '100%',
    },
    left: {
      left: `${(value / (max - min)) * 100}%`,
      transform: `translateY(-${50}%)`,
      top: '50%',
    },
    right: {
      right: `${100 - (value / (max - min)) * 100}%`,
      transform: `translateY(-${50}%)`,
      top: '50%',
    },
  };
  const indicatorStyle = indicatorStyles[indicatorPosition];
  if (duration) indicatorStyles[indicatorPosition].transitionDuration = `${duration}ms`;
  const pathStyle = {
    transform: `scaleX(${value / (max - min)})`,
    ...(duration ? { transitionDuration: `${duration}ms` } : {}),
    ...(pathProps.style || {}),
  };
  if (pathColor) {
    pathStyle.backgroundColor = pathColor;
  }
  return (
    <div
      aria-valuenow={value}
      aria-valuemin={min}
      aria-valuemax={max}
      className={classes}
      {...other}>
      <div className={`${prefixCls}-bg`} style={bgStyle}>
        <div className={`${prefixCls}-path`} {...pathProps} style={pathStyle} />
        {indicator ? (
          <div className={`${prefixCls}-indicator`} style={indicatorStyle}>
            {indicator(value)}
          </div>
        ) : null}
      </div>
      {showInfo ? <div className={`${prefixCls}-info`}>{infoFormat(value)}</div> : null}
    </div>
  );
}
LinearProgress.propTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  /** 当前值 */
  value: PropTypes.number,
  /** 最大值 */
  max: PropTypes.number,
  /** 最小值 */
  min: PropTypes.number,
  /** 进度信息 function(percent) => info: ReactNode */
  infoFormat: PropTypes.func,
  /** 是否显示进度信息 */
  showInfo: PropTypes.bool,
  /** 是否显示指示游标 */
  indicator: PropTypes.func,
  /** 指示游标显示位置 */
  indicatorPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  /** 宽度 */
  strokeWidth: PropTypes.number,
  /** 过渡动画时长 */
  duration: PropTypes.number,
  /** 进度条属性 */
  pathProps: PropTypes.object,
  /** 进度条颜色 */
  pathColor: PropTypes.string,
  color: PropTypes.oneOf(['primary', 'success', 'warning', 'info', 'error']),
};
LinearProgress.defaultProps = {
  prefixCls: 'ne-linear-progress',
  value: 0,
  infoFormat: percent => `${percent}%`,
  showInfo: true,
  indicatorPosition: 'top',
  max: 100,
  min: 0,
  pathProps: {},
  color: 'primary',
};



// WEBPACK FOOTER //
// ./src/progress/LinearProgress.jsx